import request from '@/utils/request'

// 获取VIP状态
export function getVipStatus() {
  return request({
    url: '/api/subscription/status',
    method: 'get'
  })
}

// 获取订阅历史
export function getSubscriptionHistory() {
  return request({
    url: '/api/subscription/history',
    method: 'get'
  })
}

// 兑换码兑换
export function redeemCode(code) {
  return request({
    url: '/api/redeem/exchange',
    method: 'post',
    data: { code }
  })
}